/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse';
import type { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
import {
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped,
} from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';

/**
 * 
 * @export
 * @interface FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse
 */
export interface FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse
     */
    Success: boolean;
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse
     */
    Data: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse;
    /**
     * 
     * @type {FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse
     */
    Error?: FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError | null;
}

/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse(value: object): value is FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('Data' in value) || value['Data'] === undefined) return false;
    return true;
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse {
    return FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'Data': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseToJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse {
    return FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseToJSONTyped(value?: FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'Data': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}

